import { FC } from 'react';

export const ScanMobilePass = (() => null) as FC;
